<script setup lang="ts">
import type { SubjectCode } from '~/models/Subject'
import type { GradeCode } from '~/models/Grade'
import { useRouter }  from '#imports'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { faMagnifyingGlass } from '@fortawesome/duotone-regular-svg-icons'
import { PendoFeature } from '~/models/Pendo'
import Button from '~/components/ui/Button.vue'

const props = defineProps<{ subjectCode: SubjectCode, gradeCode: GradeCode, themeColor: string }>()

const { t } = useI18n()
const router = useRouter()

const searchQuery = ref('')

const doSearch = () => router.push({
  name: 'search',
  query: {
    fullText: searchQuery.value,
    grade: props.gradeCode,
    subject: props.subjectCode,
    fromSubject: props.subjectCode,
  },
})
</script>

<template>
  <section class="space-y-6 py-16 transition-all">
    <div class="max-w-xl space-y-4">
      <h2
        class="text-2xl font-medium"
        v-text="t('search.subject', { subject: t(`metadata.subjects.${subjectCode}`).toLowerCase() })"
      />
      <form
        role="search"
        class="relative"
        @submit.prevent="doSearch"
      >
        <font-awesome-icon
          :icon="faMagnifyingGlass"
          size="xl"
          class="text-green-40 absolute top-1/2 left-5 z-10 -translate-y-1/2 text-xl"
        />
        <input
          v-model="searchQuery"
          type="text"
          maxlength="200"
          name="search"
          :aria-label="t('search.title')"
          :placeholder="t('search.placeholder')"
          class="w-full rounded-xl bg-white p-3 pl-16 text-xl transition placeholder:text-lg placeholder:text-gray-50 focus-visible:ring"
        >
        <Button
          class="absolute top-1/2 right-1.5 z-10 -translate-y-1/2"
          :disabled="!searchQuery.length"
          type="submit"
          :data-pendo="PendoFeature.Search.SubjectSearch"
        >
          {{ t('search.title') }}
        </Button>
      </form>
    </div>
  </section>
</template>
